import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Btn, Modal, Field, Input, Select } from "@/components/ui-kit";
import { formatINR, formatDate } from "@/lib/format";
import { Plus, Trash2, Receipt } from "lucide-react";

const empty = { date: "", category: "Fuel", vehicle_id: "", amount: 0, description: "" };
const CATS = ["Fuel","Maintenance","Toll","Parking","Driver Salary","Office Expense","Other"];

export default function Expenses() {
  const [items, setItems] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const [e, v] = await Promise.all([api.get("/owner/expenses"), api.get("/owner/vehicles")]);
    setItems(e.data); setVehicles(v.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e?.preventDefault();
    const data = { ...editing, amount: Number(editing.amount) };
    if (!data.vehicle_id) data.vehicle_id = null;
    await api.post("/owner/expenses", data);
    setOpen(false); setEditing(null); load();
  };

  const del = async (id) => { if (confirm("Delete expense?")) { await api.delete(`/owner/expenses/${id}`); load(); } };

  return (
    <div data-testid="expenses-page">
      <PageHeader title="Expenses" subtitle="Track maintenance, tolls, salaries and other operational costs."
        actions={<Btn data-testid="expense-add" onClick={() => { setEditing({...empty, date: new Date().toISOString().slice(0,10)}); setOpen(true); }}><Plus className="h-4 w-4" /> Add Expense</Btn>}
      />
      <div className="bg-white border border-zinc-200 rounded-lg overflow-hidden">
        <table className="tbl">
          <thead><tr><th>Date</th><th>Category</th><th>Vehicle</th><th>Amount</th><th>Description</th><th></th></tr></thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={6} className="text-center py-10 text-zinc-500"><Receipt className="h-8 w-8 mx-auto mb-2 text-zinc-300" /> No expenses yet.</td></tr>
            ) : items.map((x) => {
              const v = vehicles.find((vv) => vv.id === x.vehicle_id);
              return (
                <tr key={x.id}>
                  <td>{formatDate(x.date)}</td>
                  <td><span className="badge badge-muted">{x.category}</span></td>
                  <td className="font-mono">{v?.registration_number || "—"}</td>
                  <td className="font-mono font-bold">{formatINR(x.amount)}</td>
                  <td className="text-zinc-600">{x.description || "—"}</td>
                  <td className="text-right"><Btn variant="ghost" onClick={() => del(x.id)} data-testid={`expense-delete-${x.id}`}><Trash2 className="h-4 w-4 text-red-600" /></Btn></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title="Add Expense" testid="expense-modal"
        footer={<><Btn variant="outline" onClick={() => setOpen(false)}>Cancel</Btn><Btn data-testid="expense-save" onClick={submit}>Save</Btn></>}>
        {editing && (
          <form onSubmit={submit} className="grid grid-cols-2 gap-4">
            <Field label="Date" required><Input type="date" value={editing.date} onChange={(e) => setEditing({...editing, date: e.target.value})} required /></Field>
            <Field label="Category" required><Select value={editing.category} onChange={(e) => setEditing({...editing, category: e.target.value})}>{CATS.map((c) => <option key={c}>{c}</option>)}</Select></Field>
            <Field label="Vehicle (optional)">
              <Select value={editing.vehicle_id || ""} onChange={(e) => setEditing({...editing, vehicle_id: e.target.value})}>
                <option value="">—</option>
                {vehicles.map((v) => <option key={v.id} value={v.id}>{v.registration_number}</option>)}
              </Select>
            </Field>
            <Field label="Amount (INR)" required><Input type="number" step="0.01" value={editing.amount} onChange={(e) => setEditing({...editing, amount: e.target.value})} required /></Field>
            <div className="col-span-2"><Field label="Description"><Input value={editing.description || ""} onChange={(e) => setEditing({...editing, description: e.target.value})} /></Field></div>
          </form>
        )}
      </Modal>
    </div>
  );
}
